// Dark Theme Color Palette for Fronic Media Admin
// Modern dark glassmorphism design system

const palette = {
  // Primary brand colors (teal gradient)
  primary: {
    lightest: '#B3EDE5',
    lighter: '#66D9CC',
    light: '#12B4A1',
    main: '#12B4A1',        // Main teal accent
    dark: '#0E8B7D',
    darker: '#0596B3',      // Blue accent from gradient
    darkest: '#064D45',
    gradient: 'linear-gradient(135deg, #139979 0%, #12B4A1 50%, #0596B3 100%)',
    gradientHover: 'linear-gradient(135deg, #107D63 0%, #0E9185 50%, #047799 100%)',
    contrastText: '#FFFFFF',
  },

  // Secondary colors (dark grays for backgrounds)
  secondary: {
    lightest: '#475569',
    lighter: '#334155',
    light: '#1E293B',       // Content background
    main: '#0F172A',        // Main background
    dark: '#0B1120',
    darker: '#080D19',
    darkest: '#050911',
    contrastText: '#F1F5F9',
  },

  // Accent colors for highlights and status indicators
  accent: {
    coral: '#FF6B6B',
    amber: '#FFA726',
    lime: '#66BB6A',
    purple: '#9C27B0',
    blue: '#2196F3',
    teal: '#12B4A1',
    cyan: '#0596B3',
  },

  // Status colors with alpha variants for dark theme
  status: {
    pending: {
      main: '#FFA726',
      light: '#FFB74D',
      dark: '#F57C00',
      bg: 'rgba(255, 167, 38, 0.12)',
      border: 'rgba(255, 167, 38, 0.3)',
      contrastText: '#FFA726',
    },
    approved: {
      main: '#66BB6A',
      light: '#81C784',
      dark: '#4CAF50',
      bg: 'rgba(102, 187, 106, 0.12)',
      border: 'rgba(102, 187, 106, 0.3)',
      contrastText: '#66BB6A',
    },
    rejected: {
      main: '#FF6B6B',
      light: '#FF8A80',
      dark: '#E53935',
      bg: 'rgba(255, 107, 107, 0.12)',
      border: 'rgba(255, 107, 107, 0.3)',
      contrastText: '#FF6B6B',
    },
    takendown: {
      main: '#9E9E9E',
      light: '#BDBDBD',
      dark: '#757575',
      bg: 'rgba(158, 158, 158, 0.12)',
      border: 'rgba(158, 158, 158, 0.3)',
      contrastText: '#9E9E9E',
    },
    draft: {
      main: '#2196F3',
      light: '#64B5F6',
      dark: '#1976D2',
      bg: 'rgba(33, 150, 243, 0.12)',
      border: 'rgba(33, 150, 243, 0.3)',
      contrastText: '#2196F3',
    },
  },

  success: {
    main: '#66BB6A',
    light: '#81C784',
    dark: '#4CAF50',
    contrastText: '#FFFFFF',
  },

  error: {
    main: '#FF6B6B',
    light: '#FF8A80',
    dark: '#E53935',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#FFA726',
    light: '#FFB74D',
    dark: '#F57C00',
    contrastText: '#FFFFFF',
  },

  info: {
    main: '#2196F3',
    light: '#64B5F6',
    dark: '#1976D2',
    contrastText: '#FFFFFF',
  },

  // Dark theme backgrounds
  background: {
    default: '#0F172A',     // Main dark background
    paper: '#1E293B',       // Card/content background
    elevated: '#243147',    // Elevated surfaces
    subtle: '#162032',      // Subtle variation
    overlay: 'rgba(15, 23, 42, 0.8)',
    glass: 'rgba(30, 41, 59, 0.5)',  // Glassmorphism effect
  },

  // Text colors for dark theme
  text: {
    primary: '#F1F5F9',     // Main text
    secondary: '#E2E8F0',   // Secondary text
    muted: '#94A3B8',       // Muted text
    disabled: '#64748B',    // Disabled text
    hint: '#475569',        // Hint text
  },

  // Borders and dividers
  divider: 'rgba(255, 255, 255, 0.06)',
  border: {
    default: 'rgba(255, 255, 255, 0.06)',
    light: 'rgba(255, 255, 255, 0.08)',
    focus: 'rgba(18, 180, 161, 0.5)',
  },

  common: {
    black: '#000000',
    white: '#FFFFFF',
  },

  // Gray scale for dark theme
  grey: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },

  // Glassmorphism effects
  glass: {
    background: 'rgba(30, 41, 59, 0.5)',
    border: 'rgba(255, 255, 255, 0.08)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    blur: 'blur(20px)',
  },
};

export default palette;
